import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useTranslation } from "@hooks/useTranslation";
import LoadingCard from "./LoadingCard";
import ProductoResultado from "./ProductoResultado";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import axios from 'fetch/axios';

const ResultadosArtistas = () => {
  const { uri } = useParams();
  const params = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  const { translate } = useTranslation();
  const coleccionPosition = useRef(null);
  const [posicionsub, setPosicionsub] = useState(uri);
  const { lang, currency } = useContext(LanguageCurrencyContext);
  const [productos, setProductos] = useState([]);
  const [pages, setPages] = useState(1);
  const pageFromQuery = parseInt(params.get('page'), 10);
  const [pageCurrent, setPageCurrent] = useState((pageFromQuery && pageFromQuery > 0 && pageFromQuery !== 1) ? pageFromQuery : 1);
  const [artist, setArtist] = useState(null);
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);


  function SetPositionColeccion(event) {
    const pos = ["Vertical", "Horizontal"];
    pos[2] = event.target.dataset.n.split(",");
    event.target.parentNode.querySelector(`.icon-${pos[pos[2][0]]}`).classList.add("Selected");
    event.target.parentNode.querySelector(`.icon-${pos[pos[2][1]]}`).classList.remove("Selected");
    coleccionPosition.current.classList.toggle("ColeccionHorizontal");
    coleccionPosition.current.classList.toggle("ColeccionVertical");
  }

  const ListArtists = async () => {
    try {
      try {

        const responseca = await axios.get(`/artist?lang=` + lang);
        setArtists(responseca.data.data);

      } catch (error) {
        console.error('Error al obtener los productos:', error);
        navigate('/404')
      }


    } catch (error) {
      console.error('Error fetching category details', error);
    }
  };

  const detailArtist = async () => {
    try {

      const response = await axios.get(`/artist/detail?lang=` + lang + `&uri=` + uri + `&currency=` + currency + `&page=` + pageCurrent + `&per_page=16`);

      setArtist(response.data.name);
      setProductos(response.data.products);
      setPages(response.data.pages);
      setLoading(false)

    } catch (error) {
      console.error('Error al obtener el artista:', error);
    }

  };

  const handlePageChange = (newPage) => {
    setPageCurrent(newPage);
    // Actualiza el query string en la URL
    const params = new URLSearchParams(window.location.search);
    params.set('page', newPage);
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };


  const renderPagination = () => {
    const pageNumbers = [];
    for (let i = 1; i <= pages; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={pageCurrent === i ? 'Selected' : ''}
          style={pageCurrent === i ? {} : { "cursor": 'pointer' }}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </li>
      );
    }

    return (
      <section className="ColeccionPagination">
        <div style={{ "cursor": 'pointer' }}
          className="icon-CaretLeft"
          onClick={() => pageCurrent > 1 && handlePageChange(pageCurrent - 1)}
        ></div>
        <ul>{pageNumbers}</ul>
        <div style={{ "cursor": 'pointer' }}
          className="icon-CaretRight"
          onClick={() => pageCurrent < pages && handlePageChange(pageCurrent + 1)}
        ></div>
      </section>
    );
  };

  useEffect(() => {

    const fetchData = async () => {
      await Promise.all([
        ListArtists(),
        detailArtist(),
      ]);
    };
    fetchData();

  }, [lang, currency, pageCurrent, uri]);

  return (
    <>

      <div className={`CategoryTitle pt-tophead`}>
        <ul className="Breadcrumb">
          <li><Link to="/home">Home</Link></li>
          <li><Link to={'/' + translate('categories.our_artists_uri')}>{translate('categories.our_artists')}</Link></li>
          <li>{artist ?? '...'}</li>
        </ul>
        {<h3>{artist ?? '...'}</h3>}
      </div>

      <section className="ColeccionMenu">
        <div className="ColeccionMenuItems">
          <div>
            <div>
              <p>{translate('collections.send1')}</p>
              <ul>
                {artists && artists.map((sub) => (
                  <li
                    key={sub.id}
                    className={`${posicionsub === sub.uri ? 'Selected' : ''}`}
                    onClick={() => {
                      setPosicionsub(sub.uri);
                      setArtist(sub.name);
                      // Ajustar a la ruta correcta dependiendo si estamos en ES o EN
                      const isEnglish = window.location.pathname.includes('our-artists');
                      const basePath = isEnglish ? translate('categories.our_artists_uri') : 'nuestros-artistas';
                      navigate(`/${basePath}/${sub.uri}`);
                    }}
                  >
                    {sub.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div>
          <span className="icon-Vertical" data-n="0,1" onClick={SetPositionColeccion}>
            {translate('collections.send3')}
          </span>
          <span className="icon-Horizontal Selected" data-n="1,0" onClick={SetPositionColeccion}>
            {translate('collections.send4')}
          </span>
        </div>
      </section>

      <section
        className="ColeccionItems ColeccionVertical"
        ref={coleccionPosition}
      >
        {!loading ? productos.map((producto) => (
          <ProductoResultado
            key={producto.id || producto._id}
            producto={producto}
          />))
          :
          <>
            {<LoadingCard />}
          </>
        }

      </section>
      {pages > 1 && renderPagination()}

    </>
  );
};

export default ResultadosArtistas;
